"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSendAccount = void 0;
const accounts_1 = require("@near-js/accounts");
const core_1 = require("@multi-transaction/core");
const utils_1 = require("./utils");
class MultiSendAccount extends accounts_1.Account {
    constructor(connection, accountId) {
        super(connection, accountId);
    }
    static new(connection, accountId = '') {
        return new MultiSendAccount(connection, accountId);
    }
    static fromAccount(account) {
        return new MultiSendAccount(account.connection, account.accountId);
    }
    /**
     * Send multiple transactions and return success value of last transaction
     */
    async send(mTransaction, options = {}) {
        const { parser, ...sendRawOptions } = options;
        const outcomes = await this.sendRaw(mTransaction, sendRawOptions);
        const outcome = outcomes[outcomes.length - 1];
        return (0, core_1.parseOutcomeValue)(outcome, parser);
    }
    /**
     * Send multiple transactions and return outcomes
     */
    async sendRaw(mTransaction, options = {}) {
        const { throwReceiptErrors } = options;
        const transactions = (0, utils_1.parseNearApiJsTransactions)(mTransaction);
        if (transactions.length === 0) {
            throw new core_1.SendTransactionError('Transaction not found.');
        }
        const outcomes = [];
        for (const transaction of transactions) {
            const outcome = await this.signAndSendTransaction({ ...transaction });
            outcomes.push(outcome);
        }
        if (throwReceiptErrors) {
            (0, core_1.throwReceiptErrorsFromOutcomes)(outcomes);
        }
        return outcomes;
    }
    /**
     * Call a contract method and return success value
     */
    async call(options) {
        const { parser, ...callRawOptions } = options;
        const outcome = await this.callRaw(callRawOptions);
        return (0, core_1.parseOutcomeValue)(outcome, parser);
    }
    /**
     * Call a contract method and return outcome
     */
    async callRaw(options) {
        const { contractId, methodName, args, attachedDeposit, gas, stringifier, ...sendRawOptions } = options;
        const mTransaction = core_1.MultiTransaction.batch(contractId).functionCall({
            methodName,
            args,
            attachedDeposit,
            gas,
            stringifier,
        });
        const outcomes = await this.sendRaw(mTransaction, sendRawOptions);
        return outcomes[0];
    }
    /**
     * View a contract method and return success value
     */
    async view(options) {
        const { contractId, methodName, args, stringifier = core_1.Stringifier.json(), parser = core_1.Parser.json(), blockQuery = core_1.BlockQuery.OPTIMISTIC, } = options;
        return this.viewFunction({
            contractId,
            methodName,
            args: args,
            stringify: (args) => stringifier.stringifyOrSkip(args),
            parse: (buffer) => parser.parse(buffer),
            blockQuery: blockQuery.toReference(),
        });
    }
}
exports.MultiSendAccount = MultiSendAccount;
//# sourceMappingURL=MultiSendAccount.js.map